/**
 * Main application business page
 */
import "./style.css";
import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "redux-react/middleware/ws";
import ChartsActions from "redux-react/actions/chartsActions";
import FilesActions from "redux-react/actions/filesActions";
import FormAction from "redux-react/actions/formAction";
import { useMaterialUIController } from "context";
import ChartsLoader from "components/Custom/ChartsLoader";
import MDTypography from "components/Basics/MDTypography";
import { getLocalStorageBackValues } from "components/Custom/Filters/filters";
import DefaultDataTable from "components/Custom/Tables/DefaultDataTable";
import { Divider, Fade, Icon, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MDButton from "components/Basics/MDButton";
import { display } from "redux-react/reducers/snackBarReducer";
import SoundPlayer from "components/Custom/SoundPlayer";
import { getPermissions } from "redux-react/reducers/permissionsReducer";
import PhoneCall from "./components/PhoneCall";
import { useUrlQuery } from "hooks/useUrlQuery";
import useFilters from "hooks/useFilters";

/**
 * Default component to display charts, works with dynamic datas
 */
export default function PhoneCallPage({ route }) {
	/** URL Query params */
	const getUrlQuery = useUrlQuery();
	const [filtersURL, setFiltersURL] = useState(getUrlQuery());
	/**  */

	const dispatch = useDispatch();
	const { profile, filters } = useSelector(state => state);
	const { permissions } = useSelector(getPermissions);
	const [controller] = useMaterialUIController();
	const { darkMode } = controller;
	const rightPannelContainer = useRef(null);
	// Loader while charts are loading
	const [chartsLoading, setChartsLoading] = useState(false);
	// Page Charts
	const [charts, setCharts] = useState([]);
	// Filters configuration for the page
	const [pageFilters, setPageFilters] = useState([]);

	const [openPannel, setOpenPannel] = useState(false);
	const [phoneCall, setPhoneCall] = useState({});

	const [reloadTable, setReloadTable] = useState(false);

	const [anchorElMenu, setAnchorElMenu] = useState(null);

	const [fullScreen, setFullScreen] = useState(false);

	const [menuRef, setMenuRef] = useState(null);
	const [menuValues, setMenuValues] = useState({});

	// tab for right menu
	const [tab, setTab] = useState(0);
	// right menu loading
	const [visualiseConversationLoading, setVisualiseConversationLoading] = useState(true);

	// Dictionary for dialog
	const [dictionary, setDictionary] = useState({});

	// Resource controller
	const [resource, setResource] = useState(null);

	// Generate filters components
	const filtersComponents = useFilters(route.route, pageFilters);

	const canExecActions = () => {
		return permissions.includes("exec:biovanciaActions");
	};

	/**
	 * Get charts data to be displayed in front
	 */
	function getChartsData(typeList) {
		return charts.filter(chart => typeList.includes(chart.type));
	}
	/**
	 * Get charts with filters from the back
	 */
	async function getCharts(requestFilters, pageFilters) {
		let mandatoryFilters = pageFilters.map(filter => filter.attribute);

		return new Promise((resolve, reject) => {
			dispatch(
				ChartsActions.getPageCharts(
					profile.assistantID,
					route,
					{ ...requestFilters, ...filtersURL },
					mandatoryFilters,
					res => resolve(res.charts)
				)
			);
		});
	}
	/**
	 * Get filters from back
	 */
	async function getPageFilters() {
		if (route.filter) {
			// If route has filter, get it
			return new Promise((resolve, reject) => {
				dispatch(
					ChartsActions.getPageFilters(profile.assistantID, route.filter, res => {
						resolve(res.filters);
					})
				);
			});
		} else {
			// return empty array
			return [];
		}
	}
	/**
	 * Load charts from back
	 */
	async function loadCharts() {
		// Get all filters from back
		let pageFilters = await getPageFilters();
		setPageFilters(pageFilters);
		// Get filters from local storage
		let actualFilters = getLocalStorageBackValues(
			profile.selectedAssistant.assistantID,
			route.route,
			filters
		);
		// Build charts with filters
		let chartsFromDatabase = await getCharts(actualFilters, pageFilters);
		setCharts(chartsFromDatabase);

		const list = chartsFromDatabase[0];
		if (!lod_.isNil(list)) {
			setDictionary(list.dictionary);
			setResource(list.resource);
		}

		setChartsLoading(false);
	}

	/**
	 * Reset URL query filters
	 */
	const resetUrlQuery = () => {
		setFiltersURL({}); // Reset state
		window.history.replaceState({}, "", window.location.pathname); // Reset URL
		loadCharts(); // Reload charts
	};

	/**
	 * Load charts when assistant changes or route changes
	 */
	useEffect(() => {
		setChartsLoading(true);
		loadCharts();
	}, [profile.selectedAssistant.assistantID, route]);

	const categoryzeAllFiles = () => {
		dispatch(
			display({
				message: `Catégorisation des fichiers en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.categoryzeAllFiles(profile.assistantID, res => {
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Les fichiers ont été catégorisés avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const cleanAllFiles = () => {
		dispatch(
			display({
				message: `Nettoyage des fichiers en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.cleanAllFiles(profile.assistantID, res => {
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Les fichiers ont été nettoyés avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const analyseAllFiles = () => {
		dispatch(
			display({
				message: `Analyse des fichiers en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.analyzeAllFiles(profile.assistantID, res => {
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Les fichiers ont été analysés avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const cleanFile = code => {
		dispatch(
			display({
				message: `Nettoyage du fichier en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.cleanFile(profile.assistantID, code, res => {
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Le fichier a été nettoyé avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const analyseFile = code => {
		dispatch(
			display({
				message: `Analyse de la conversation en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.analyzeFile(profile.assistantID, code, res => {
				setPhoneCall(res?.conv || {});
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Le fichier a été analysé avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const customerRework = code => {
		dispatch(
			display({
				message: `Rework du client en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.customerRework(profile.assistantID, code, res => {
				if (res.conv) {
					setPhoneCall(res.conv);
				}
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Le client a été reworké avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const analyzeProducts = code => {
		dispatch(
			display({
				message: `Recherche de produits en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.analyzeProducts(profile.assistantID, code, res => {
				setPhoneCall(res?.conv || {});
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `La recherche de produits a été effectuée avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const analyzeActions = code => {
		dispatch(
			display({
				message: `Analyse des actions en cours`,
				type: "info"
			})
		);
		dispatch(
			FilesActions.analyzeActions(profile.assistantID, code, res => {
				setPhoneCall(res?.conv || {});
				setReloadTable(!reloadTable);
				dispatch(
					display({
						message: `Les actions ont été analysées avec succès`,
						type: "success"
					})
				);
			})
		);
	};

	const closePannel = () => {
		setOpenPannel(false);
		setFullScreen(false);
		setPhoneCall({});
	};

	function listenPhoneCall(code) {
		socket.emit("listen_conversation_phone_call", { code });
	}

	function listenPhoneCallResult({ url }) {
		if (!url) {
			dispatch(
				display({
					message: `Impossible de lire l'enregistrement`,
					type: "error"
				})
			);
			return;
		}

		setPhoneCall(prev => {
			return {
				...phoneCall,
				url
			};
		});
	}

	const visualiseConversation = (fID = menuValues.fID) => {
		setVisualiseConversationLoading(true);
		setPhoneCall({
			fID
		});
		if (!resource?.storage?.collection) {
			dispatch(display({ message: "Impossible de visualiser la conversation", type: "error" }));
		} else {
			dispatch(
				FormAction.getItemsFromCollection(
					resource?.storage?.collection,
					{
						query: {
							fID,
							active: { $in: [true, false, null] }
						}
					},
					res => {
						let conversation = res.items[0];
						if (!conversation) {
							setOpenPannel(false);
							setVisualiseConversationLoading(false);
							dispatch(display({ message: "Aucune conversation trouvée", type: "error" }));
							return;
						}

						setOpenPannel(true);

						setVisualiseConversationLoading(false);
						setPhoneCall(conversation);

						listenPhoneCall(conversation.fID);

						// if scroll in page is above rightPannelContainer ref, scroll to it
						setTimeout(() => {
							let scrollPosition = document.documentElement.scrollTop;
							let pannelTopPosiiton = rightPannelContainer.current.offsetTop;

							if (scrollPosition < pannelTopPosiiton) {
								rightPannelContainer.current.scrollIntoView({
									behavior: "smooth",
									block: "start"
								});
							}
						}, 200);
					}
				)
			);
		}
	};

	const updatePhoneCall = ({ conversation }) => {
		if (phoneCall.fID !== conversation.fID) {
			return;
		}
		setPhoneCall(conversation);
	};

	useEffect(() => {
		socket.on("update_conversation_phone_call", updatePhoneCall);
		socket.on("listen_conversation_phone_call_result", listenPhoneCallResult);
		return () => {
			socket.off("update_conversation_phone_call", updatePhoneCall);
			socket.off("listen_conversation_phone_call_result", listenPhoneCallResult);
		};
	}, [phoneCall]);

	/* Charts loader */
	if (chartsLoading) {
		return (
			<DashboardLayout>
				<MDBox py={3}>
					<DashboardNavbar />
					<ChartsLoader darkMode={darkMode} />
				</MDBox>
			</DashboardLayout>
		);
	} else
		/* Main component */
		return (
			<DashboardLayout>
				<MDBox py={3}>
					{pageFilters && (
						<DashboardNavbar
							filters={[
								<MDBox
									display="flex"
									justifyContent="space-between"
									style={{
										width: "100%"
									}}
								>
									{/* First container */}
									{lod_.isEmpty(filtersURL) && <MDBox display="flex">{filtersComponents}</MDBox>}
									{!lod_.isEmpty(filtersURL) && (
										<MDBox display="flex" alignItems="center" flexDirection="row">
											<MDButton
												style={{ height: "100%", marginRight: "0.75rem" }}
												variant="contained"
												color="info"
												onClick={resetUrlQuery}
											>
												<Icon>clear</Icon>&nbsp;Réinitialiser les filtres
											</MDButton>
										</MDBox>
									)}
									{/* Second container */}
									{canExecActions() && (
										<MDButton
											variant="contained"
											color="dark"
											onClick={e => {
												setAnchorElMenu(e.currentTarget);
											}}
										>
											<Icon>list_alt</Icon>&nbsp;Actions fichiers
										</MDButton>
									)}
									{/* Menu */}
									<Menu
										anchorEl={anchorElMenu}
										open={Boolean(anchorElMenu)}
										onClose={() => setAnchorElMenu(null)}
										anchorOrigin={{
											vertical: "bottom",
											horizontal: "center"
										}}
										transformOrigin={{
											vertical: "top",
											horizontal: "center"
										}}
									>
										{/* Actions */}
										<MenuItem
											onClick={() => {
												setAnchorElMenu(null);
												cleanAllFiles();
											}}
										>
											<Icon>cleaning_services_icon</Icon>&nbsp;Nettoyer tous les fichiers
										</MenuItem>
										<MenuItem
											onClick={() => {
												setAnchorElMenu(null);
												analyseAllFiles();
											}}
										>
											<Icon>memory</Icon>&nbsp;Analyser tous les fichiers
										</MenuItem>
										<MenuItem
											onClick={() => {
												setAnchorElMenu(null);
												categoryzeAllFiles();
											}}
										>
											<Icon>class</Icon>&nbsp;Catégoriser tous les fichiers
										</MenuItem>
									</Menu>
								</MDBox>
							]}
						/>
					)}
				</MDBox>

				{/* Pagined table */}
				{getChartsData(["paginedList"]).map((chart, index) => {
					return (
						<MDBox
							key={index}
							className="pageContentContainer"
							style={{
								display: openPannel ? "flex" : "block"
							}}
						>
							{!fullScreen && (
								<MDBox flex="1">
									<DefaultDataTable
										onRowClick={row => {
											if (phoneCall?.fID !== row.fID) {
												setMenuValues(row);
												visualiseConversation(row.fID);
											}
										}}
										isSelectedRow={row => {
											return row.fID === phoneCall.fID;
										}}
										dictionary={chart.dictionary}
										reloadTable={reloadTable}
										id={chart.code}
										list={chart}
										pagination={chart.pagination}
										canSearch
										table={chart.data}
										display={chart.request.attributesDisplay}
										filters={{
											...getLocalStorageBackValues(
												profile.selectedAssistant.assistantID,
												route.route,
												filters
											),
											...filtersURL
										}}
										actions={[
											<IconButton
												handleclick={({ values }, e) => {
													setMenuValues(values);
													setMenuRef(e.currentTarget);
													e.stopPropagation();
												}}
											>
												<Icon fontSize="medium">more_vert</Icon>
											</IconButton>
										]}
									/>
								</MDBox>
							)}
							{openPannel && phoneCall && (
								<MDBox
									className={fullScreen ? "rightPannelContainerFullScreen" : "rightPannelContainer"}
									ref={rightPannelContainer}
								>
									<PhoneCall
										tab={tab}
										setTab={setTab}
										phoneCall={phoneCall}
										closePannel={closePannel}
										visualiseConversationLoading={visualiseConversationLoading}
										fullScreen={fullScreen}
										setFullScreen={setFullScreen}
										resource={resource?.storage?.collection}
									/>
								</MDBox>
							)}
						</MDBox>
					);
				})}

				{/* Menu actions selection */}
				<Menu
					open={Boolean(menuRef)}
					anchorEl={menuRef}
					onClose={() => {
						setMenuRef(null);
					}}
				>
					{/*  */}
					{canExecActions() && (
						<div>
							<MenuItem disabled style={{ opacity: 1 }}>
								<MDTypography variant="caption">Actions principales</MDTypography>
							</MenuItem>
							<MenuItem
								disabled={!["transcripted", "cleaned", "analyzed"].includes(menuValues.state)}
								onClick={() => {
									cleanFile(menuValues.code);
									setMenuRef(null);
								}}
							>
								<Icon fontSize="medium">cleaning_services_icon</Icon>&nbsp;Nettoyer le fichier
							</MenuItem>
							<MenuItem
								disabled={!["cleaned", "analyzed"].includes(menuValues.state)}
								onClick={() => {
									analyseFile(menuValues.code);
									setMenuRef(null);
								}}
							>
								<Icon fontSize="medium">memory</Icon>&nbsp;Analyser le fichier
							</MenuItem>
							{/*  */}
							<Divider />
							<MenuItem disabled style={{ opacity: 1 }}>
								<MDTypography variant="caption">Actions secondaires</MDTypography>
							</MenuItem>
							<MenuItem
								disabled={!["analyzed"].includes(menuValues.state)}
								onClick={() => {
									customerRework(menuValues.code);
									setMenuRef(null);
								}}
							>
								<Icon fontSize="medium">face</Icon>&nbsp;Informations client
							</MenuItem>
							<MenuItem
								disabled={!["analyzed"].includes(menuValues.state)}
								onClick={() => {
									analyzeActions(menuValues.code);
									setMenuRef(null);
								}}
							>
								<Icon fontSize="medium">list</Icon>&nbsp;Analyser les actions
							</MenuItem>
							<MenuItem
								disabled={!["analyzed"].includes(menuValues.state)}
								onClick={() => {
									analyzeProducts(menuValues.code);
									setMenuRef(null);
								}}
							>
								<Icon fontSize="medium">shopping_cart</Icon>&nbsp;Recherche de produits
							</MenuItem>
							<Divider />
						</div>
					)}
					{/* Chat */}
					<MenuItem disabled style={{ opacity: 1 }}>
						<MDTypography variant="caption">Conversation</MDTypography>
					</MenuItem>
					<MenuItem
						// disabled={menuValues.dialog === undefined}
						onClick={() => {
							visualiseConversation();
							setMenuRef(null);
						}}
					>
						<Icon fontSize="medium">chat</Icon>&nbsp;Voir la discussion
					</MenuItem>
				</Menu>

				<MDBox mt={10}></MDBox>

				{/* Floating button */}
				<Fade in={Boolean(phoneCall.url)}>
					<div
						style={{
							position: "fixed",
							bottom: 20,
							right: "50%",
							transform: "translateX(50%)",
							zIndex: 1000
						}}
					>
						<SoundPlayer src={phoneCall.url} />
					</div>
				</Fade>
			</DashboardLayout>
		);
}
